const GET_INQUIRIES_REQUESTED = "GET_INQUIRIES_REQUESTED";
const GET_INQUIRIES_SUCCEEDED = "GET_INQUIRIES_SUCCEEDED";
const GET_INQUIRIES_FAILED = "GET_INQUIRIES_FAILED";

export {
  GET_INQUIRIES_REQUESTED,
  GET_INQUIRIES_SUCCEEDED,
  GET_INQUIRIES_FAILED
}
